import { Message, MessageTag } from "../general";

export class TerminateActiveSessionsRequest extends Message
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_TERMINATE_ACTIVE_SESSIONS;
  public static tag : MessageTag = MessageTag.REQ_TERMINATE_ACTIVE_SESSIONS;

  public expectsReply () : boolean { return true; }

  public constructor (public includeSelf : boolean = true)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/auth/terminate-active-sessions-request.ts